import { Component } from '@angular/core';

@Component({
  selector: 'ncp-logout',
  imports: [],
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.scss',
})
export class LogoutComponent {}
